import { Box, Button, Image, Text } from '@bonanza-social/moonlight';
import { memo } from 'react';
import { BottomSheetExtendedProps } from '@bonanza-social/navigation';
import { useNavigation } from '@bonanza-social/navigation';
import { StackNavigationProp } from '@bonanza-social/navigation';
import { Trans } from 'react-i18next';

function ShopInfo({ close }: BottomSheetExtendedProps) {
  const navigation =
    useNavigation<StackNavigationProp<AppNavigatorParamsList>>();

  const handlePlayWithCoinsPress = () => {
    navigation.navigate('PlayWithCoinsScreen');
  };

  return (
    <Box alignItems="center" gap="space-600">
      <Text
        variant="h5"
        color="darkSurfacePrimary"
        locNS="shop"
        locKey="shopInfoTitle"
        textAlign="center"
      />
      <Image name="common.BonanzaCoinStack" width={200} height={155} />
      <Text
        variant="body-m"
        color="darkSurfacePrimary"
        locNS="shop"
        locKey="shopInfoMessage"
        textAlign="center"
      />
      <Text
        variant="body-m"
        color="darkSurfacePrimary"
        locNS="shop"
        locKey="shopInfoMessageRedeem"
        textAlign="center"
      >
        <Trans
          ns="shop"
          i18nKey="shopInfoMessageRedeem"
          components={{
            playWithCoins: (
              <Text
                variant="link-medium"
                gradient="darkSurfaceAccent"
                onPress={handlePlayWithCoinsPress}
              />
            ),
          }}
        />
      </Text>
      <Button
        width="100%"
        variant="primary"
        locNS="shop"
        locKey="shopInfoCta"
        onPress={close}
      />
    </Box>
  );
}

export default memo(ShopInfo);
